import { useState } from "react";

export default function CsvUploader({ onFileSelect }) {
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            onFileSelect && onFileSelect(file);
        }
    };

    return (
        <div className="flex flex-wrap items-center gap-3 min-w-0">
            {/* Hidden file input */}
            <input
                id="csvInput"
                type="file"
                accept=".csv,.xls,.xlsx"
                className="hidden"
                onChange={handleFileChange}
            />

            {/* Button to browse or change */}
            <label
                htmlFor="csvInput"
                className="cursor-pointer bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
            >
                {selectedFile ? "Change File" : "Browse File"}
            </label>

            {/* Show selected file name */}
            {selectedFile && (
                <span className="text-sm text-gray-700 truncate max-w-xs">
                    {selectedFile.name}
                </span>
            )}
        </div>
    );
}
